<template>
    <ServiceStatisticsForm />
  </template>
  
  <script>
  import ServiceStatisticsForm from '@/components/statistics/allServiceStats/ServiceStatisticsForm.vue';
  
    export default {
      components: {
        ServiceStatisticsForm
      }
    }
  </script>
  
  <style lang="scss" scoped>
  
  </style>